import React, { useEffect, useState } from "react";
import MyProfileDetails from "../MyProfileDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateUserDetails, getCurrentUser, getLoggedUserDetails,
  getPicUpdatedStatus,
  getUserProfilePic,
  getUserUpdateStatus, loadUserDetails,
  loadUserProfilePic,
  updateUserProfilePic,
  userDetailsUpdated,
  userProfilePicUpdated
} from "../../app/store/auth";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import { getAlert } from "../../services/appAlerts";
import { Modal } from "react-bootstrap";

const formatUSPhoneNumber = (phoneNo) => {
  if (!phoneNo) return "";
  const cleaned = ("" + phoneNo).replace(/\D/g, "");
  const match = cleaned.match(/^(1)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[2]}) ${match[3]}-${match[4]}`;
  }
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  return phoneNo;
};

const PartnerProfile = (props) => {
  const { profileShowHide, handleProfileShowHide } = props;


  const [profileEdit, setProfileEdit] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [profilePicObj, setProfilePicObj] = useState(null);
  const [profilePicData, setProfilePicData] = useState(null);

  const loggedUserDetailsSelector = useSelector(getLoggedUserDetails);
  const updateStatusSelector = useSelector(getUserUpdateStatus)
  const picUpdatedStatusSelector = useSelector(getPicUpdatedStatus);
  const userProfilePicSelector = useSelector(getUserProfilePic);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    dispatch(setCurrentPageTitle("My Profile"));
    dispatch(setCurrentRoute([]));
    dispatch(userProfilePicUpdated(true))
  }, [])

  useEffect(() => {
    if (currentUser?.id) {
      dispatch(loadUserDetails(currentUser.id));
    }
  }, []);

  useEffect(() => {
    if (loggedUserDetailsSelector)
      setUserDetails(loggedUserDetailsSelector);
  }, [loggedUserDetailsSelector])

  useEffect(() => {
    if (userProfilePicSelector) {
      //let objectURL = 'data:image/jpeg;base64,' + userProfilePicSelector;
      setProfilePicData(userProfilePicSelector);
    }
  }, [userProfilePicSelector])

  useEffect(() => {
    if (updateStatusSelector === "success" && currentUser?.id) {
      getAlert("", "Updated Successfully", "success");
      // dispatch(loadUserDetails(currentUser.id));
    } else if (updateStatusSelector === "fail") {
      getAlert("", "Update Failed", "error");
    }
    dispatch(loadUserDetails(currentUser.id));
    return () => {
      dispatch(userDetailsUpdated(null));
    }
  }, [updateStatusSelector])


  const handleSubmit = async (profile) => {
    dispatch(UpdateUserDetails(profile));
    handleUpdatePic();
    dispatch(loadUserDetails(currentUser.id));
  };

  const handleUpdatePic = () => {
    const frmData = new FormData();
    frmData.append("userId", currentUser?.id);
    frmData.append("files[0]", profilePicObj?.file);
    dispatch(updateUserProfilePic(frmData));
  }

  useEffect(() => {
    if (picUpdatedStatusSelector) {
      dispatch(loadUserProfilePic(currentUser.id));
    }
  }, [picUpdatedStatusSelector])

  const handleImageChange = (e) => {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      setProfilePicObj({
        file: file,
        fileName: file.name,
        imagePreviewUrl: reader.result,
      })
    };

    reader.readAsDataURL(file);
  };

  const handleEditProfile = () => {
    setProfileEdit(!profileEdit);
  };

  let $imagePreview = null;
  if (profilePicObj) {
    $imagePreview = <img src={profilePicObj.imagePreviewUrl}
      alt="profile" className="img-thumbnail rounded-circle profilePrev" />
  } else {
    $imagePreview = <img
      alt="profile" className="img-thumbnail rounded-circle profilePrev"
      src={`${!profilePicData ? "../../assets/img/theme/team-4.png" : process?.env?.REACT_APP_API_BASEURL + "/ProfilePics/" + profilePicData}`}
    />
  }

  return (
    <React.Fragment>
      <Modal
        show={profileShowHide}
        onHide={handleProfileShowHide}
        dialogClassName="rt-profile-modal theme-primary"
        centered
        backdrop="static"
      >
        <style>{`

        /* Ensure the modal and backdrop are on top of sidebars/headers */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }

        .rt-profile-modal {
          width: min(1100px, calc(100vw - 64px)) !important;
          max-width: min(1100px, calc(100vw - 64px)) !important;
          height: auto !important;
        }
        .rt-profile-modal .modal-content {
          border-radius: 0 !important;
          box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1) !important;
          border: 1px solid #cbd5e1 !important;
          overflow: hidden !important;
          background: #ffffff !important;
          width: 100% !important;
          max-width: 100% !important;
          height: auto !important;
          max-height: calc(100vh - 60px) !important;
          display: flex !important;
          flex-direction: column !important;
          font-family: inherit !important;
        }
        .rt-profile-modal .modal-header {
          position: relative !important;
          padding: 16px 20px !important;
          background: #ffffff !important;
          border-bottom: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
        }
        .rt-profile-modal .modal-header::before {
          display: none !important;
        }
        .rt-profile-modal .rt-header-shell {
          width: 100% !important;
        }
        .rt-profile-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          gap: 12px !important;
        }
        .rt-profile-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex: 1 !important;
        }
        .rt-profile-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          min-width: 0 !important;
        }
        .rt-profile-modal .rt-header-icon {
          width: 52px !important;
          height: 52px !important;
          min-height: 52px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #171717 !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: 0 2px 6px -2px rgba(15,23,42,0.08) !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
        }
        .rt-profile-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #1e293b !important;
          font-size: 18px !important;
          font-weight: 500 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }
        .rt-profile-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }
        .rt-profile-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 3px 8px !important;
          height: 22px !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-size: 11px !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: #171717 !important;
          color: #ffffff !important;
          border: 1px solid #171717 !important;
          line-height: 1 !important;
        }
        .rt-profile-modal .rt-modal-meta-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 8px !important;
          margin-top: 0 !important;
          padding-left: 0 !important;
          font-size: 12px !important;
          font-weight: 400 !important;
          color: #64748b !important;
        }
        .rt-profile-modal .rt-meta-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          background: #ffffff !important;
          padding: 3px 8px !important;
          height: 24px !important;
          min-height: 24px !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-size: 11.5px !important;
          font-weight: 500 !important;
          color: #0f172a !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: none !important;
          line-height: 1 !important;
        }
        .rt-profile-modal .rt-meta-chip i,
        .rt-profile-modal .rt-meta-chip .fa {
          font-size: 11.5px !important;
          margin-right: 4px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        .rt-profile-modal .rt-meta-chip i.fa-user { color: #9333ea !important; }
        .rt-profile-modal .rt-meta-chip i.fa-envelope, .rt-profile-modal .rt-meta-chip i.fa-envelope-o { color: #0284c7 !important; }
        .rt-profile-modal .rt-meta-chip i.fa-phone { color: #16a34a !important; }
        .rt-profile-modal .rt-meta-chip i.fa-hashtag { color: #d97706 !important; }
        .rt-profile-modal .rt-meta-chip i.fa-folder-open { color: #2563eb !important; }
        .rt-profile-modal .rt-meta-chip i.fa-id-badge { color: #6366f1 !important; }

        .rt-profile-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 32px !important;
          height: 32px !important;
          padding: 0 !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          outline: none !important;
          font-family: inherit !important;
        }
        .rt-profile-modal .rt-action-btn:hover {
          color: #dc2626 !important;
          border-color: #fca5a5 !important;
          background: #fef2f2 !important;
          transform: translateY(-1px) !important;
        }

        .rt-profile-modal .modal-body {
          padding: 20px 24px !important;
          background: #ffffff !important;
          max-height: calc(100vh - 200px) !important;
          overflow-y: auto !important;
        }
        .rt-profile-modal .modal-footer {
          background: #ffffff !important;
          border-top: 1px solid #e2e8f0 !important;
          padding: 14px 20px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 10px !important;
        }
        .rt-profile-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          padding: 7px 18px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          font-family: inherit !important;
        }
        .rt-profile-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
        }
        /* Form styling matching AddWorkflowPerformer */
        .rt-profile-modal .form-control-label {
          font-size: 11px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.7px !important;
          margin-bottom: 6px !important;
          display: flex !important;
          align-items: center !important;
          gap: 5px !important;
        }
        .rt-profile-modal .form-control-label i,
        .rt-profile-modal .wf-control-label i,
        .rt-profile-modal .wf-input-icon {
          display: none !important;
        }
        .rt-profile-modal .form-group {
          margin-bottom: 16px !important;
        }

        .rt-profile-modal .form-control,
        .rt-profile-modal select.form-control,
        .rt-profile-modal .input-group .form-control {
          border-radius: 0 !important;
          border: 1.5px solid #e2e8f0 !important;
          padding: 9px 14px !important;
          font-size: 13.5px !important;
          color: #1e293b !important;
          background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
          width: 100% !important;
          height: auto !important;
        }
        .rt-profile-modal .wf-input-wrap .form-control {
          padding: 9px 14px !important;
        }
        .rt-profile-modal .form-control::placeholder {
          color: #94a3b8 !important;
        }
        .rt-profile-modal .form-control:hover,
        .rt-profile-modal select.form-control:hover {
          border-color: #94a3b8 !important;
          box-shadow: 0 2px 6px -1px rgba(0, 0, 0, 0.06) !important;
        }
        .rt-profile-modal .form-control:focus,
        .rt-profile-modal select.form-control:focus,
        .rt-profile-modal .input-group .form-control:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1), 0 2px 6px -1px rgba(37, 99, 235, 0.08) !important;
          outline: none !important;
          background-color: #fafbff !important;
        }
        .rt-profile-modal .form-control:disabled,
        .rt-profile-modal select.form-control:disabled {
          background-color: #f8fafc !important;
          color: #475569 !important;
          border-color: #e2e8f0 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
        }
        .rt-profile-modal select.form-control {
          appearance: none !important;
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          background-color: #ffffff !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2364748b'/%3E%3C/svg%3E") !important;
          background-repeat: no-repeat !important;
          background-position: right 12px center !important;
          background-size: 10px 6px !important;
          padding-right: 32px !important;
          cursor: pointer !important;
        }
        .rt-profile-modal select.form-control:focus {
          background-color: #fafbff !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%232563eb'/%3E%3C/svg%3E") !important;
          background-repeat: no-repeat !important;
          background-position: right 12px center !important;
          background-size: 10px 6px !important;
        }

        .rt-profile-card {
          display: grid !important;
          grid-template-columns: 260px 1fr !important;
          gap: 20px !important;
        }
        .rt-profile-aside {
          background: #f8fafc !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
          padding: 24px 16px !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          text-align: center !important;
        }
        .rt-profile-avatar-wrap {
          position: relative !important;
          width: 100px !important;
          height: 100px !important;
          margin-bottom: 14px !important;
        }
        .rt-profile-avatar-wrap img,
        .profilePrev {
          width: 100px !important;
          height: 100px !important;
          object-fit: cover !important;
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
        }
        .profileBtn {
          position: absolute !important;
          bottom: -4px !important;
          right: -4px !important;
          width: 28px !important;
          height: 28px !important;
          border-radius: 0 !important;
          background: #171717 !important;
          color: #ffffff !important;
          border: 1px solid #ffffff !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          cursor: pointer !important;
          font-size: 11px !important;
        }
        .rt-profile-name {
          font-size: 15px !important;
          font-weight: 600 !important;
          color: #0f172a !important;
          margin: 0 0 4px !important;
        }
        .rt-profile-email {
          font-size: 12px !important;
          color: #64748b !important;
          margin: 0 !important;
          word-break: break-all !important;
        }
        .rt-profile-form-card {
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
          padding: 20px 24px !important;
        }
        .rt-profile-form-head {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          margin-bottom: 20px !important;
          padding-bottom: 14px !important;
          border-bottom: 1px solid #f1f5f9 !important;
        }
        .rt-profile-form-title {
          font-size: 15px !important;
          font-weight: 600 !important;
          color: #0f172a !important;
          margin: 0 0 2px !important;
        }
        .rt-profile-form-subtitle {
          font-size: 12px !important;
          color: #64748b !important;
          margin: 0 !important;
        }
        .rt-profile-edit-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          padding: 6px 14px !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #ffffff !important;
          background: #2563eb !important;
          border: 1px solid #2563eb !important;
          border-radius: 0 !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
        }
        .rt-profile-edit-btn:hover {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          color: #ffffff !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.28) !important;
        }
        .rt-profile-form-actions {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 12px !important;
          margin-top: 24px !important;
          padding-top: 18px !important;
          border-top: 1.5px solid #f1f5f9 !important;
        }
        .rt-profile-btn-cancel {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 7px !important;
          padding: 8px 22px !important;
          font-size: 13px !important;
          font-weight: 500 !important;
          color: #334155 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06) !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          font-family: inherit !important;
        }
        .rt-profile-btn-cancel:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          box-shadow: 0 2px 6px rgba(15, 23, 42, 0.1) !important;
        }
        .rt-profile-btn-update {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 7px !important;
          padding: 8px 24px !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #ffffff !important;
          background: #2563eb !important;
          border: 1px solid #2563eb !important;
          border-radius: 0 !important;
          box-shadow: 0 2px 6px rgba(37, 99, 235, 0.25) !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          font-family: inherit !important;
        }
        .rt-profile-btn-update:hover {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          color: #ffffff !important;
          box-shadow: 0 4px 10px rgba(37, 99, 235, 0.35) !important;
        }
        @media (max-width: 768px) {
          .rt-profile-card {
            grid-template-columns: 1fr !important;
          }
        }
  `}</style>
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className="rt-header-icon fa fa-user-circle-o" aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>My Profile</span>
                      <span className="rt-modal-title-badge">
                        {profileEdit ? "Editing" : "View"}
                      </span>
                    </span>
                  </h2>
                  <div className="rt-modal-meta-row">
                    {userDetails?.performername && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-user" aria-hidden="true" style={{ color: "#9333ea", marginRight: "4px" }} />
                        <span>{userDetails.performername}</span>
                      </span>
                    )}
                    {userDetails?.performeremail && (
                      <span className="rt-meta-chip" title={userDetails.performeremail}>
                        <i className="fa fa-envelope" aria-hidden="true" style={{ color: "#0284c7", marginRight: "4px" }} />
                        <span>{userDetails.performeremail}</span>
                      </span>
                    )}
                    {userDetails?.contactNo && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-phone" aria-hidden="true" style={{ color: "#16a34a", marginRight: "4px" }} />
                        <span>{formatUSPhoneNumber(userDetails.contactNo)}</span>
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={handleProfileShowHide}
                title="Close Profile"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="rt-profile-card">
            <aside className="rt-profile-aside">
              <div className="rt-profile-avatar-wrap">
                {$imagePreview}
                <label className="profileBtn" title={profileEdit ? "Change profile photo" : "Enable edit to change photo"}>
                  <input
                    type="file"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                    disabled={!profileEdit}
                  />
                  <i className="fa fa-camera" aria-hidden="true"></i>
                </label>
              </div>
              <h3 className="rt-profile-name">{userDetails?.performername || "My Profile"}</h3>
              <p className="rt-profile-email">{userDetails?.performeremail || currentUser?.email || ""}</p>
            </aside>
            <div className="rt-profile-form-card">
              <div className="rt-profile-form-head">
                <div>
                  <h3 className="rt-profile-form-title">Profile Details</h3>
                  <p className="rt-profile-form-subtitle">
                    {profileEdit ? "Update your contact and address information." : "Review your contact and address information."}
                  </p>
                </div>
                {!profileEdit &&
                  <button
                    type="button"
                    className="rt-profile-edit-btn"
                    onClick={handleEditProfile}
                  >
                    <i className="fa fa-edit" aria-hidden="true"></i> Edit
                  </button>}
              </div>
              <MyProfileDetails
                userDetails={userDetails}
                handleSubmit={handleSubmit}
                profileEdit={profileEdit}
                setProfileEdit={setProfileEdit}
                handleEditProfile={handleEditProfile}
              ></MyProfileDetails>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={handleProfileShowHide}
          >
            <i className="fa fa-times" aria-hidden="true" />
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

export default PartnerProfile;
